import { io } from "socket.io-client";
import store from "@/state/store";

let socket = null;

export function initChatSocket(token) {
  if (socket && socket.connected) return;

  const chatUrl =
    process.env.VUE_APP_CHAT_API || "https://api-n.nkrdieselparts.com";

  socket = io(`${chatUrl}/chat`, {
    auth: { type: "agent", token },
    transports: ["websocket"],
    autoConnect: false
  });

  socket.on("connect", () => {
    store.commit("chat/SET_CONNECTED", true);
    store.dispatch("chat/onSocketReconnected");
  });

  socket.on("disconnect", () => {
    store.commit("chat/SET_CONNECTED", false);
  });

  socket.on("chat:new_conversation", data => {
    store.dispatch("chat/onNewConversation", data);
  });

  socket.on("chat:conversation_taken", data => {
    store.dispatch("chat/onConversationTaken", data);
  });

  socket.on("chat:join_success", data => {
    store.dispatch("chat/onJoinSuccess", data);
  });

  socket.on("chat:join_failed", ({ conversationId }) => {
    store.dispatch("chat/onConversationTaken", { conversationId });
    alert("Another agent took this conversation first.");
  });

  socket.on("chat:message", data => {
    store.dispatch("chat/onMessageReceived", data);
  });

  socket.on("chat:closed", data => {
    store.dispatch("chat/onChatClosed", data);
  });

  socket.on("chat:conversation_transferred", data => {
    store.dispatch("chat/onConversationTransferred", data);
  });

  socket.connect();
}

export function watchConversation(conversationId) {
  if (socket) socket.emit("chat:watch", { conversationId });
}

export function joinConversation(conversationId) {
  if (socket) socket.emit("chat:join", { conversationId });
}

export function sendAgentMessage(conversationId, body) {
  if (socket) socket.emit("chat:agent_message", { conversationId, body });
}

export function sendAgentImage(conversationId, imageUrl) {
  if (socket)
    socket.emit("chat:agent_message", {
      conversationId,
      body: imageUrl,
      messageType: "image"
    });
}

export function closeConversation(conversationId) {
  if (socket) socket.emit("chat:close", { conversationId });
}

export function disconnectChat() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
